import axios from 'axios';
import { toolUtils } from '../../../../utils/toolUtils.js'
import pfn from './LinkFns.js'
import { message, Upload } from 'antd';
export default {
  createLink: async function (conferenceUid, values, setFuncMap) {
    let payload = {
      "lang": values.lang,
      "url": values.url,
      "coverImage": values.coverImage,
      "remark": values.remark,
    }
    setFuncMap.setIsModalLoading(true)
    const res = await this.createLinkAction(conferenceUid, payload)
    pfn.getLinks({ conferenceUid }, setFuncMap)
    setFuncMap.setIsModalLoading(false)
    setFuncMap.setIsModalOpen(false)
    setFuncMap.message.open({
      key: "create",
      type: 'success',
      content: 'Create success',
      duration: 2,
    });
  },
  createLinkAction: (conferenceUid, payload) => {
    return axios.post(`/conference/${conferenceUid}/link`, payload, {
      headers: {
        "role": "topUser"
      }
    })
  },
  getLinkById: async function (conferenceUid, id, setFuncMap) {
    try {
      const res = await this.getLinkByIdAction(conferenceUid, id);
      let data = res.data
      if (data) {
        // data.startAt = toolUtils.convertStringToDatetime(data.startAt)
        // data.endAt = toolUtils.convertStringToDatetime(data.endAt)
        setFuncMap.setFieldsValue(data)
        setFuncMap.setFileList([{
          uid: data.id,
          name: "uploaded file",//`${window.CONFS.cloudDomain}/${data.coverImage}`,
          status: 'done',
          url: `${window.CONFS.cloudDomain}/${data.coverImage}`,
          thumbUrl: `${window.CONFS.cloudDomain}/${data.coverImage}`,
        }])
        setFuncMap.setIsGetLink(true)
        if (data.content) {
          setFuncMap.setEditorData(data.content)
        }
      }
    }
    catch (e) {

    }

  },
  getLinkByIdAction: (conferenceUid, id) => {
    return axios.get(`/conference/${conferenceUid}/link/${id}`, {
      headers: {
        "role": "topUser"
      }
    })
  },
  updateLink: async function (conferenceUid, values, setFuncMap) {
    let payload = {
      "id": values.id,
      "lang": values.lang,
      "url": values.url,
      "coverImage": values.coverImage,
      "remark": values.remark,
    }
    setFuncMap.setIsModalLoading(true)
    console.log({ payload })
    const res = await this.updateLinkAction(conferenceUid, payload)
    pfn.getLinks({ conferenceUid }, setFuncMap)
    setFuncMap.setIsModalLoading(false)
    setFuncMap.setIsModalOpen(false)
    setFuncMap.message.open({
      key: "update",
      type: 'success',
      content: 'Update success',
      duration: 2,
    });
  },
  updateLinkAction: (conferenceUid, payload) => {
    return axios.post(`/conference/${conferenceUid}/link/${payload.id}`, payload, {
      headers: {
        "role": "topUser"
      }
    })
  },
  generateUploadProps: function (form, linkList, setFuncMap) {
    return {
      beforeUpload: (file) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          message.error('You can only upload JPG/PNG file!');
          return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          message.error('Image must smaller than 2MB!');
          return Upload.LIST_IGNORE;
        }
        return true;
      },
      customRequest: (options) => {
        this.handleUpload(options, form)
      },
      listType: "picture",
      defaultFileList: linkList,
      maxCount: 1
    };
  },
  handleUpload: ({ file, onSuccess, onError, onProgress }, form) => {
    const formData = new FormData();
    formData.append('file', file);
    axios.post('/upload-files/top-user', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        "role": "topUser"
      },
      onUploadProgress: (event) => {
        const percent = Math.round((event.loaded * 100) / event.total);
        onProgress({ percent });
      },
    })
      .then(response => {
        let data = response.data
        onSuccess({ url: `${window.CONFS.cloudDomain}/${data.fileName}`, ...response.data });
        form.setFieldsValue({
          coverImage: data.fileName,
        })
        // message.success(`${file.name} file uploaded successfully`);
      })
      .catch(error => {
        onError(error);
        message.error(`${file.name} file upload failed.`);
      });
  }
}